
import React from "react";

import { navItems } from "../../constants";

import { Link } from "react-router-dom";

import { motion } from "framer-motion";

import { useStateContext } from "../../context/ContextProvider";

function Navebar({ active }) {

  const { currentDir } = useStateContext();

  return (

    <nav className="hidden lg:flex items-center gap-3">

      {
        navItems.map((item, index) => (

          <Link
            key={item.id}
            to={item.link}
            onClick={() => window.scrollTo(0, 0)}
          >

            <motion.div
              whileHover={{ y: -2 }}
              className={`
                relative
                px-5 py-3
                rounded-2xl
                font-kufi
                text-lg
                font-semibold
                transition-all duration-300
                overflow-hidden
                ${
                  active === index + 1
                    ? "text-white"
                    : "text-color-1 dark:text-white hover:text-color-1"
                }
              `}
            >

              {
                active === index + 1 && (
                  <motion.div
                    layoutId="navbar-active"
                    className="
                      absolute inset-0
                      bg-color-1
                      rounded-2xl
                      shadow-lg
                    "
                    transition={{
                      type: "spring",
                      bounce: 0.2,
                      duration: 0.6,
                    }}
                  />
                )
              }

              <span className="relative z-10">

                {
                  currentDir === "ltr"
                    ? item.titleEn
                    : item.titleAr
                }

              </span>

            </motion.div>

          </Link>

        ))
      }

    </nav>
  );
}

export default Navebar;

